import { Injectable, Inject, ElementRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';

const PRINT_TIMEOUT = 500;

@Injectable({ providedIn: 'root' })
export class PrintService {
  printFinished = true;
  private printSection: HTMLElement;

  constructor(@Inject(DOCUMENT) private readonly document: Document) {
    this.init();
  }

  init(): void {
    let printSection = this.document.getElementById('printSection');
    if (!printSection) {
      printSection = this.document.createElement('div');
      printSection.id = 'printSection';
      this.document.body.appendChild(printSection);
    }
    this.printSection = printSection;
  }

  print(elemToPrint: ElementRef): void {
    this.printSection.innerHTML = '';

    // eslint-disable-next-line max-len
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
    const domClone = elemToPrint.nativeElement.cloneNode(true) as HTMLElement;
    const appendResult: HTMLElement = this.printSection.appendChild(domClone);

    this.printFinished = false;
    window.print();

    window.onfocus = (): void => {
      setTimeout(() => {
        if (!this.printFinished) {
          appendResult.style.display = 'none';
          this.printFinished = true;
        }
      }, PRINT_TIMEOUT);
    };
  }
}
